// src/utils/siteRegion.js
// ---------------------------------------------------------------------------
// Where a site is, as far as the analyses need to know without a geocoder.
//
// Two things were wrong for any site outside India: Sun Path kept India's UTC
// offset (+5.5) for every project, so a New York site's "20:00" sun was really
// mid-morning; and Cost priced every site from Indian rates without saying the
// site was elsewhere. Both only need a coarse answer, and both say so on screen.
// ---------------------------------------------------------------------------

/**
 * Roughly within India: its bounding box, 6.5–37.5°N, 68–97.5°E. Coarse on purpose
 * — it takes in slivers of neighbouring countries — which is fine for choosing a
 * default and for a warning; nothing here decides a regulation.
 */
export function inIndia(lat, lng) {
  const la = Number(lat);
  const ln = Number(lng);
  return Number.isFinite(la) && Number.isFinite(ln) && la >= 6.5 && la <= 37.5 && ln >= 68 && ln <= 97.5;
}

/**
 * A starting UTC offset for a site: India Standard Time inside India, otherwise
 * the whole-hour zone its longitude falls in. Real zones follow borders and daylight
 * saving, so outside India this is an estimate the user can correct — `estimated`
 * says which it is.
 */
export function utcOffsetFor(lat, lng) {
  if (inIndia(lat, lng)) return { tz: 5.5, estimated: false };
  const ln = Number(lng);
  if (!Number.isFinite(ln)) return { tz: 5.5, estimated: true };
  const tz = Math.max(-12, Math.min(14, Math.round(ln / 15)));
  return { tz: Object.is(tz, -0) ? 0 : tz, estimated: true };
}
